import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FocusActivePictoProps extends pictoProps {
}

export interface FocusActivePictoState extends pictoState {
}

export class FocusActivePicto extends Picto<FocusActivePictoProps,FocusActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.focusActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FocusActivePicto);
